/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $( ".WrapSearch .fa-search" ).click(function() {
          $( this ).parent().toggleClass( "active" );
        });

        if ( $(".owl-carousel-thumb-post").length > 0 ) {
          $(".owl-carousel-thumb-post").owlCarousel({
            loop:false,
            margin:20,
            responsiveClass:true,
            navText:[
              '<i class="fa fa-angle-left"></i>',
              '<i class="fa fa-angle-right"></i>'
            ],
            responsive:{
                0:{
                    items:2,
                    nav:true
                },
                200:{
                    items:2,
                    nav:true
                },
                400:{
                    items:4,
                    nav:true
                },
                600:{
                    items:6,
                    nav:true
                }
            }
          });
        } 

        var mm_bindnavbar = function() {
          if ($(window).width() > 767) {
            $('.navbar-collapse .dropdown').on('mouseover', function(){
              $('.dropdown-toggle', this).next('.dropdown-menu').show();
              $('.dropdown-toggle', this).parent().addClass('active open');
            }).on('mouseout', function(){
              $('.dropdown-toggle', this).next('.dropdown-menu').hide();
              $('.dropdown-toggle', this).parent().removeClass('active open');
            });
            
            $('.dropdown-toggle').click(function() {
              if ($(this).next('.dropdown-menu').is(':visible')) {
                window.location = $(this).attr('href');
              }
            });
          }
          else {
            $('.navbar-collapse .dropdown').off('mouseover').off('mouseout');
            $('.navbar-collapse').on('show.bs.dropdown', function () {
              return false;
            });
          }
        };

        $(window).resize(function() {
          mm_bindnavbar();
        });

        mm_bindnavbar();
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $(".owl-carousel-posts").owlCarousel({
          loop:true,
          margin:20,
          responsiveClass:true,
          navText:[
            '<i class="fa fa-angle-left"></i>',
            '<i class="fa fa-angle-right"></i>'
          ],
          responsive:{
              0:{
                  items:1,
                  nav:true
              },
              500:{
                  items:2,
                  nav:true
              },
              700:{
                  items:3,
                  nav:true
              },
              1000:{
                  items:4,
                  nav:true
              }
          }
        });

        $(".owl-carousel-home").owlCarousel({
          loop:true,
          nav:true,
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navText:[
            '<i class="fa fa-angle-left"></i>',
            '<i class="fa fa-angle-right"></i>'
          ],
          items:1
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
